<p class="footer-fixed">



     Copyright  © {{currentYear}} V Partner, All rights reserved.
</p>